import React from 'react';
import { Users, TrendingUp, MapPin, DollarSign } from 'lucide-react';
import { propertyData } from '../../data/mock';

const RelocationSection = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-[#161b22] to-[#0d1117]" data-testid="relocation-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 bg-amber-500/10 border border-amber-500/30 rounded-full text-amber-400 text-sm font-medium tracking-wide mb-4">
            Relocation Opportunity
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-serif text-white mb-6">
            {propertyData.relocationData.headline}
          </h2>
          <p className="text-2xl font-serif text-amber-400 mb-4">
            {propertyData.relocationData.subheadline}
          </p>
          <p className="text-lg text-white/70 font-light">
            {propertyData.relocationData.description}
          </p>
        </div>

        {/* Migration Stats Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {propertyData.relocationData.stats.map((stat) => (
            <div 
              key={stat.label}
              className="bg-gradient-to-br from-white/5 to-white/[0.02] border border-white/10 rounded-2xl p-6 text-center hover:border-amber-500/30 transition-all"
            >
              <p className="text-3xl md:text-4xl font-bold text-amber-400 mb-2">
                {stat.value}
              </p>
              <p className="text-white/70 text-sm font-light mb-3">
                {stat.label}
              </p>
              <p className="text-white/40 text-xs italic">
                Source: {stat.source}
              </p>
            </div>
          ))}
        </div>

        {/* Capital Conversion Message */}
        <div className="max-w-4xl mx-auto">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-amber-500/10 to-transparent rounded-2xl blur-xl" />
            <div className="relative bg-gradient-to-br from-[#1a1f2e] to-[#0d1117] border border-amber-500/20 rounded-2xl p-8 md:p-10">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <div>
                  <h3 className="text-2xl font-serif text-white mb-4">
                    Converting Capital Into Legacy
                  </h3>
                  <p className="text-white/70 font-light leading-relaxed mb-6">
                    In many high-cost markets, several million dollars can be absorbed by a single 
                    residence on limited land. At William Lane, capital can be converted into:
                  </p>
                  <ul className="space-y-3">
                    {['Acreage', 'Privacy', 'Infrastructure', 'Flexibility', 'Legacy'].map((item) => (
                      <li key={item} className="flex items-center text-white/80">
                        <div className="w-2 h-2 rounded-full bg-amber-400 mr-3" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="space-y-4">
                  <div className="bg-white/5 rounded-xl p-4">
                    <div className="flex items-center space-x-3 mb-2">
                      <Users className="w-5 h-5 text-amber-400" />
                      <span className="text-white font-medium">Target Buyer Segments</span>
                    </div>
                    <ul className="space-y-2">
                      {propertyData.relocationData.targetBuyers.map((buyer) => (
                        <li key={buyer} className="text-white/60 text-sm flex items-start">
                          <span className="text-amber-400 mr-2">•</span>
                          {buyer}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Disclaimer */}
        <p className="text-center text-white/40 text-xs mt-8 max-w-2xl mx-auto">
          Migration data represents broader market trends. Not every Florida migrant is a luxury buyer, 
          but within the broader flow is a high-value segment seeking properties like William Lane Estate.
        </p>
      </div>
    </section>
  );
};

export default RelocationSection;
